import { api } from './api'

/**
 * The Arcade (staged library) surface — `arcade_*` in
 * backend-nest/docs/api-contract.md, shipped by V7-b.
 *
 * Two reads, no writes: progress is a side effect of practising, so the
 * path is recomputed on every GET — stars from `lessonScore` against
 * `arcade.starThresholds`, locks from `arcade.lessonUnlock` /
 * `arcade.stageUnlock`. Nothing is cached here for that reason: coming back
 * from a lesson must re-ask rather than redraw a path from before the take.
 */

/**
 * One level's path: published stages in order, each with its lessons
 * carrying `locked`, `stars`, `lessonScore` and `completed`, plus `current`
 * — the first unlocked, unfinished lesson (null on a finished or empty
 * path). Without `level` the server answers the learner's own.
 *
 * 403 `premium_required` while `arcade.requirePremium` is on and the
 * learner has no active Tooti+ (Q22; the setting is off today) —
 * `isPremiumRequired` in lib/arcade.js is how a caller tells that apart
 * from any other refusal.
 */
export async function fetchPath({ level } = {}) {
  const { data } = await api.get('/arcade/path', { params: { level } })
  return data
}

/** One published stage, resolved inside its path — the same object the path lists. 404 for a draft one. */
export async function fetchStage(stageId) {
  const { data } = await api.get(`/arcade/stage/${stageId}`)
  return data
}
